export default __webpack_public_path__ + "static/media/Literarte-documentation.a68224cd.md";